export default "<p>\n    <b>Generate texts.</b>\n</p>"